var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcon5 = function SvgIcon5(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 66,
    viewBox: "0 0 59 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4684 0H21.9195L19.6523 25.7928H29.7356L27.4684 0Z",
    fill: "#cdd2d7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1621 8.63399H28.2289L27.7894 3.63354H21.6016L21.1621 8.63399Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6305 0H35.0816L32.8145 25.7928H42.8977L40.6305 0Z",
    fill: "#cdd2d7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3242 8.63399H41.391L40.9515 3.63354H34.7637L34.3242 8.63399Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0996 39.21V43.6823H52.3675C53.1909 43.6823 53.8584 44.3498 53.8584 45.1734V65.7148H58.6196V44.0426C58.6196 41.3735 56.456 39.21 53.787 39.21H43.0996Z",
    fill: "#8e939f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0532 44.9325H49.1028C48.307 44.9325 47.6621 44.2874 47.6621 43.4916V39.2998C47.6621 38.5041 48.307 37.8589 49.1028 37.8589H50.0532C50.8489 37.8589 51.4941 38.5041 51.4941 39.2998V43.4916C51.4941 44.2874 50.8489 44.9325 50.0532 44.9325Z",
    fill: "#8e939f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4102 65.7151H45.9339V25.6958H11.4102V65.7151Z",
    fill: "#1d2535"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4054 65.7148H0.458984V39.0732C0.458984 33.5652 4.92413 29.1001 10.432 29.1001C15.9403 29.1001 20.4054 33.5652 20.4054 39.0732V65.7148Z",
    fill: "#cdd2d7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2439 65.7148H23.9531V45.2919C23.9531 41.0694 27.3761 37.6465 31.5985 37.6465C35.821 37.6465 39.2439 41.0694 39.2439 45.2919V65.7148Z",
    fill: "#cdd2d7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31055 65.7152H20.4059V39.4912H6.31055V65.7152Z",
    fill: "#8e939f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8047 65.7148H39.2448V46.7776H28.8047V65.7148Z",
    fill: "#8e939f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2695 32.732H32.9891V27.7556H28.2695V32.732Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8848 32.732H41.6041V27.7556H36.8848V32.732Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon5.a21fb21a.svg";
export { ForwardRef as ReactComponent };